import * as React from "react";
import type { SVGProps } from "react";
const ArrowShapeIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M13.345 7.05H3v9.9h10.345V21L21 12l-7.655-9zm1.5.029V8.55H4.5v6.9h10.345v1.471L19.03 12z" clipRule="evenodd" /></svg>;
export default ArrowShapeIcon;